import { gql } from "@apollo/client";

export const API_KEY_GET_BONUS_SATS = gql`
  query GetBonusSats {
    bonusSats: getBonusSats
  }
`;
